import { Component, Input } from '@angular/core';
import { ComponentBase } from 't4core';

export interface InstructionSlide {
  image: string;
  video?: string;
  text?: string;
  title?: string;
  alt?: string;
}

@Component({
  selector: 'app-instruction-slider',
  templateUrl: './instruction-slider.component.html',
  styleUrls: ['./instruction-slider.component.css'],
  standalone: false
})
export class InstructionSliderComponent extends ComponentBase {
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() secondaryColor: boolean = true;
  @Input() slides: InstructionSlide[] = [];

  public currentSlideIndex: number = 0;
  public failedVideos: { [index: number]: boolean } = {};

  public get isFirstSlide(): boolean {
    return this.currentSlideIndex === 0;
  }

  public get isLastSlide(): boolean {
    return this.currentSlideIndex === this.slides.length - 1;
  }

  public nextSlide(): void {
    if (!this.slides?.length || this.isLastSlide) {
      return;
    }

    this.currentSlideIndex++;
  }

  public previousSlide(): void {
    if (!this.slides?.length || this.isFirstSlide) {
      return;
    }

    this.currentSlideIndex--;
  }

  public shouldShowVideo(index: number): boolean {
    return !!this.slides?.[index]?.video && !this.failedVideos[index];
  }

  public onVideoError(index: number): void {
    this.failedVideos[index] = true;
  }
}
